import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import Avatar from '@material-ui/core/Avatar';
import ImagePickerModal from './ImagePickerModal';

const IMAGE_STYLE = {
  width: '100px',
  height: '100px',
  objectFit: 'cover',
  cursor: 'pointer',
};

const BUTTON_STYLE = {
  minWidth: '100px',
  height: '40px',
  marginTop: '50px',
  marginBottom: '10px',
  textTransform: 'none',
};

const CENTER_CONTAINER = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
};

const ImageDisplay = ({ data, onChange, listCode }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (data?.image?.url) {
      setSelectedImage(data.image.url);
    } else {
      setSelectedImage(null);
    }
  }, [data]);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleImageChange = (event, type, key) => {
    if (type === 'image' && key === 'url') {
      setSelectedImage(event.target.value);
    }
    onChange(event, type, key);
    // Modal will close itself after selection
    setIsModalOpen(false);
  };

  return (
    <div style={CENTER_CONTAINER}>
      {selectedImage ? (
        <Avatar
          src={selectedImage}
          alt="Selected"
          onClick={handleClick}
          style={IMAGE_STYLE}
          variant="rounded"
        />
      ) : (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<AddPhotoAlternateIcon />}
          onClick={handleClick}
          aria-label="Mynd"
          style={BUTTON_STYLE}
        >
          Mynd
        </Button>
      )}
      <ImagePickerModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onChange={handleImageChange}
        listCode={listCode}
      />
    </div>
  );
};

export default ImageDisplay;
